/**
 * Toggles specific array member via filter
 * @param select {function}
 * @param array {array}
 * @param key {string}
 * @param execute {boolean} - return or execute method
 * @return {function(*): void}
 */
export default function toggleArrayMember(select, array, key, execute = false) {
    if (!array.includes(key)) {
        const selectMethod = () => select([...array, key])
        if (execute) {
            selectMethod()
        } else {
            return (e) => {
                e.stopPropagation();
                selectMethod()
            }
        }
    } else {
        const filterMethod = () => select(array.filter((item) => item !== key ?? item))
        if (execute) {
            filterMethod()
        } else {
            return (e) => {
                e.stopPropagation();
                filterMethod()
            }
        }
    }
}